// src/components/Footer.js
import React from "react";
import { Layout } from "antd";

const { Footer } = Layout;

const PageFooter = () => {
  return <Footer>&copy; 2024 Hyopearl Blog</Footer>;
};

export default PageFooter;
